import React from "react";

import { Loader2 } from "lucide-react";

interface RelationshipAccountsLoaderProps {
  label: string;
  /** Centers loader in the main content viewport (initial page load). */
  centered?: boolean;
}

const RelationshipAccountsLoader: React.FC<RelationshipAccountsLoaderProps> = ({
  label,
  centered = false,
}) => (
  <div
    className={
      centered
        ? "rl-prototype-skin flex min-h-[calc(100vh-10rem)] w-full flex-col items-center justify-center gap-3 bg-white text-center"
        : "rl-prototype-skin flex min-h-[320px] flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-gray-300 bg-white p-8 text-center"
    }
    aria-busy="true"
    aria-live="polite"
  >
    <Loader2 className="h-8 w-8 animate-spin text-violet-600" aria-hidden />
    <span className="text-sm font-medium text-gray-600">{label}</span>
  </div>
);

export default RelationshipAccountsLoader;
